<div class="modal__header modal__header--alert">
	<h2 class="title" id="modal__title">{{ 'modals.sessionTimeout.title.sessionExpired' | ibeadmin: 'sync' }}</h2>
</div>
<div class="modal__body sl--scrollable">
	{{ 'modals.sessionTimeout.text.beenHereTooLong' | ibeadmin: 'sync' }}<br>
	{{ 'modals.sessionTimeout.text.discardedChanges' | ibeadmin: 'sync' }}
	
</div>
<div class="modal__footer">
	<div class="modal__footer-action">
		<!-- <button class="button" (click)="INDRA_goToBookingsList()">All my bookings</button> -->
		<button class="button button--small button-accent" (click)="INDRA_confirm()">{{ 'modals.sessionTimeout.text.newSearch' | ibeadmin: 'sync' }}</button>
	</div>
</div>
